<template>
  <div class="card-buttons">
    <ButtonIcon
      icon="x"
      @click="handleCancel"
    />
    <ButtonIcon
      icon="check"
      @click="handleConfirm"
    />
  </div>
</template>

<script setup lang="ts">
import ButtonIcon from '@/components/widgets/ButtonIcon.vue';

const emit = defineEmits(['confirm', 'cancel']);

const props = defineProps({
  stopCancelPropagation: {
    type: Boolean,
    required: false,
    default: false,
  },
  stopConfirmPropagation: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const handleConfirm = (event) => {
  if (props.stopConfirmPropagation) {
    event.stopPropagation();
    event.preventDefault();
  }
  emit('confirm');
};

const handleCancel = (event) => {
  if (props.stopCancelPropagation) {
    event.stopPropagation();
    event.preventDefault();
  }
  emit('cancel');
};
</script>
